import { render, staticRenderFns } from "./ClcReportCustomer.vue?vue&type=template&id=2675b498&"
import script from "./ClcReportCustomer.vue?vue&type=script&lang=js&"
export * from "./ClcReportCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ClcReportCustomer.vue?vue&type=style&index=0&id=2675b498&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports